"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteMultiSelectValidator = void 0;
const validator_1 = require("./validator");
const utils_1 = require("./utils");
const remoteChoice_1 = require("./remoteChoice");
class RemoteMultiSelectValidator extends validator_1.CommonValidator {
    merge(props) {
        return new RemoteMultiSelectValidator({ ...this.props, ...props });
    }
    path(path) {
        return this.merge({ path });
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        return (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [this.validateType, this.validateOptions]
        });
    };
    logCustom = async ({ rootCtx, ctx, next, options: { api: { search, internal } = {} } }) => {
        const path = (await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.path)) || "";
        const options = await (0, remoteChoice_1.getOptions)(path, search, internal);
        ctx.addMessageWithPath({ options });
        return next();
    };
    validateType = async ({ ctx, next }) => {
        if (Array.isArray(ctx.value)) {
            return next();
        }
        ctx.addError({ type: "array" });
    };
    validateOptions = async ({ rootCtx, ctx, next, options: { api: { search, internal } = {} } }) => {
        const path = (await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.path)) || "";
        const options = await (0, remoteChoice_1.getOptions)(path, search, internal);
        const allValuesKnown = ctx.value.every((value) => (0, remoteChoice_1.isKnownValue)(options, value));
        if (allValuesKnown) {
            return next();
        }
        return ctx.addError({ path });
    };
    isEmptyValue(value) {
        return value === undefined || value === null;
    }
}
exports.RemoteMultiSelectValidator = RemoteMultiSelectValidator;
